export const SNIPPET_LANGUAGES = [
    {id: 'curl', label: 'cURL'},
    {id: 'javascript', label: 'JavaScript (axios)'},
    {id: 'php', label: 'PHP'},
    {id: 'python', label: 'Python'},
];

function toQueryString(query) {
    if (!query) return '';
    const params = new URLSearchParams(query).toString();
    return params ? `?${params}` : '';
}

function phpValue(v) {
    if (v === null || v === undefined) return 'null';
    if (typeof v === 'boolean') return v ? 'true' : 'false';
    if (typeof v === 'number') return String(v);
    if (Array.isArray(v)) return `[${v.map(phpValue).join(', ')}]`;
    if (typeof v === 'object') return phpArray(v);
    return `'${String(v).replace(/'/g, "\\'")}'`;
}

function phpArray(obj, indent = '    ') {
    const entries = Object.entries(obj).map(([k, v]) => `${indent}'${k}' => ${phpValue(v)}`);
    return `[\n${entries.join(',\n')}\n${indent.slice(4)}]`;
}

function pythonValue(v) {
    if (v === null || v === undefined) return 'None';
    if (typeof v === 'boolean') return v ? 'True' : 'False';
    if (typeof v === 'number') return String(v);
    if (Array.isArray(v)) return `[${v.map(pythonValue).join(', ')}]`;
    if (typeof v === 'object') return pythonDict(v);
    return `'${String(v).replace(/'/g, "\\'")}'`;
}

function pythonDict(obj, indent = '    ') {
    const entries = Object.entries(obj).map(([k, v]) => `${indent}'${k}': ${pythonValue(v)}`);
    return `{\n${entries.join(',\n')}\n${indent.slice(4)}}`;
}

function buildCurl({method, url, query, body, binaryOutput}) {
    const fullUrl = url + toQueryString(query);
    const lines = [`curl -X ${method} "${fullUrl}" \\`, `  -H "X-API-Key: qrsk_votre_cle_ici"`];
    if (body) {
        lines[lines.length - 1] += ' \\';
        lines.push(`  -H "Content-Type: application/json" \\`);
        lines.push(`  -d '${JSON.stringify(body)}'${binaryOutput ? ' \\' : ''}`);
    }
    if (binaryOutput) {
        if (!body) lines[lines.length - 1] += ' \\';
        lines.push(`  -o ${binaryOutput}`);
    }
    return lines.join('\n');
}

function buildJavascript({method, url, query, body, binaryOutput}) {
    const fullUrl = url + toQueryString(query);
    const options = [
        `  method: '${method.toLowerCase()}'`,
        `  url: '${fullUrl}'`,
        `  headers: {'X-API-Key': 'qrsk_votre_cle_ici'}`,
    ];
    if (body) options.push(`  data: ${JSON.stringify(body, null, 2).replace(/\n/g, '\n  ')}`);
    if (binaryOutput) options.push(`  responseType: 'arraybuffer'`);

    let code = `import axios from 'axios';\n\nconst response = await axios({\n${options.join(',\n')},\n});\n`;
    code += binaryOutput
        ? `\nimport fs from 'fs';\nfs.writeFileSync('${binaryOutput}', response.data);`
        : `\nconsole.log(response.data);`;
    return code;
}

function buildPhp({method, url, query, body, binaryOutput}) {
    const fullUrl = url + toQueryString(query);
    const lines = [
        `<?php`,
        `$ch = curl_init('${fullUrl}');`,
        `curl_setopt($ch, CURLOPT_RETURNTRANSFER, true);`,
    ];
    const headers = ["'X-API-Key: qrsk_votre_cle_ici'"];
    if (body) headers.push("'Content-Type: application/json'");
    lines.push(`curl_setopt($ch, CURLOPT_HTTPHEADER, [${headers.join(', ')}]);`);
    if (method !== 'GET') {
        lines.push(`curl_setopt($ch, CURLOPT_CUSTOMREQUEST, '${method}');`);
    }
    if (body) {
        lines.push(`curl_setopt($ch, CURLOPT_POSTFIELDS, json_encode(${phpArray(body)}));`);
    }
    lines.push(`$response = curl_exec($ch);`, `curl_close($ch);`);
    lines.push(binaryOutput ? `file_put_contents('${binaryOutput}', $response);` : `echo $response;`);
    return lines.join('\n');
}

function buildPython({method, url, query, body, binaryOutput}) {
    const fullUrl = url + toQueryString(query);
    const args = [`    '${fullUrl}'`, `    headers={'X-API-Key': 'qrsk_votre_cle_ici'}`];
    if (body) args.push(`    json=${pythonDict(body).replace(/\n/g, '\n    ')}`);

    let code = `import requests\n\nresponse = requests.${method.toLowerCase()}(\n${args.join(',\n')},\n)\n`;
    code += binaryOutput
        ? `\nwith open('${binaryOutput}', 'wb') as f:\n    f.write(response.content)`
        : `\nprint(response.json())`;
    return code;
}

const BUILDERS = {curl: buildCurl, javascript: buildJavascript, php: buildPhp, python: buildPython};

export function buildSnippet(language, spec) {
    const builder = BUILDERS[language] || buildCurl;
    return builder(spec);
}
